import { pxToRem } from 'utils/convert';
import { CreatorFilterTab } from './types';

export const TABLE_GRID = `
    ${pxToRem(40)} // checkbox
    minmax(${pxToRem(160)}, 1fr) // name
    minmax(${pxToRem(160)}, 1fr) // description
    ${pxToRem(200)} // last modified
    ${pxToRem(36)} // overflow
`;

export const CREATOR_FILTER_TABS: CreatorFilterTab[] = [
  {
    id: 'all',
    label: 'All',
  },
  {
    id: 'created-by-me',
    label: 'Created by me',
  },
];
